export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'));
    // console.log(user)
    // console.log(user.token)
    // console.log(user.token)

    if (user && user.token) {
        // console.log(`JWT ${user.token}`)
        
        return { Authorization: `JWT ${user.token}`};
        // return { Authorization: `Basic btoa("admin" + ":" + "obe1234")`};

        // headers.set('Authorization', 'Basic ' + btoa("admin" + ":" + "obe1234"));
    } else {
        return {};
    }
}